// extracted by mini-css-extract-plugin
export default {"root":"IconEdit_root__fk+5p","pencil":"IconEdit_pencil__zAxfO"};